export const urlWithParams = (
  url: string,
  args:
    | string
    | string[][]
    | Record<string, string>
    | URLSearchParams
    | undefined
): string => {
  const formattedData = new URLSearchParams(args).toString();

  return `${url}?${formattedData}`;
};
